import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-down-alt",
  "use": "arrow-down-alt-usage",
  "viewBox": "0 0 25 24",
  "content": "<symbol viewBox=\"0 0 25 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"arrow-down-alt\">\n<path d=\"M12.5 17.9999C12.1929 17.9999 11.8857 17.8827 11.6517 17.6483L4.45172 10.4483C3.98297 9.97959 3.98297 9.22021 4.45172 8.75146C4.92047 8.28271 5.67985 8.28271 6.1486 8.75146L12.5 15.1049L18.8525 8.7524C19.3212 8.28365 20.0806 8.28365 20.5493 8.7524C21.0181 9.22115 21.0181 9.98053 20.5493 10.4493L13.3493 17.6493C13.115 17.8837 12.8075 17.9999 12.5 17.9999Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol